import {Skeleton, Stack} from '@mui/material';

export function LogsLoading() {
  return (
    <Stack gap={2}>
      <Skeleton animation="wave" variant="rounded" height="20px" />
      <Skeleton animation="wave" variant="rounded" height="20px" />
      <Skeleton animation="wave" variant="rounded" height="20px" />
    </Stack>
  );
}
